class holidays {
  constructor(id, name) {
    this.id = id;
    this.name = name;
  }
  static fromJson({ tipoFerId, nombre }) {
    return new holidays(tipoFerId, nombre);
  }
}
export default holidays;
